import { EffectiveValues } from '@hkm/shared/effectiveValues/effectiveValues';

export const MaintenanceEffectiveValues: Map<keyof EffectiveValues, any> = new Map<keyof EffectiveValues, any>()
  .set('enableMaintenanceMobileApplication', true);



// WEBPACK FOOTER //
// ./src/components/Maintenance/shared/config/maintenanceEffectiveValues.ts